import request from '@/utils/api.utils';

export function fetchUsers(params) {
  const url = `/users`;
  return request.get(url, { params });
}

